<template>
  <div class="footer">
    <div class="container">
      <ul class="list">
        <li class="item">生日蛋糕</li>
        <li class="item">精品图书</li>
        <li class="item">节日礼包</li>
        <li class="item">影音会员</li>
        <li class="item">健康服务</li>
        <li class="item">团建活动</li>
        <li class="item">关于我们</li>
      </ul>
      <div class="desc-wrapper">
        <div class="right">
          <div class="imgs"><img src="../assets/images/logo2.jpg"></div>
          <div class="txt">看购福利公众号</div>
        </div>
        <div class="left">
          <div class="desc">客服电话：400-6776-501 (周一至周日9:00－21:00 节假日：09:00－21:00)</div>
            <div class="desc"><span class="s1">京公网安备 11010502025658</span><span class="hr">|</span><span class="s2">京ICP备 12023713号-2</span></div>
            <div class="desc">北京看购科技有限公司</div>
            <div class="desc">©2021 看购电影 kangou.com</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerBar',
  data () {
    return {

    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer{
  width: 100%;
  min-width: 1200px;
  background-color: #000;
  border-bottom: 1px solid #d8d8d8;
}
.container {
  padding-top: 20px;
  padding-bottom: 20px;
  width: 1200px;
  height: 280px;
  margin: 0 auto;
  color: #ccc;
  box-sizing: border-box;
}
.list{
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 80%;
  display: flex;
  justify-content: space-around;
}
.list .item{
  width: 1;
}
.list .item:hover{
  color: #fff;
}
.desc-wrapper{
  margin: 0 auto;
  width: 70%;
}
.desc-wrapper .right{
  padding-top: 20px;
  float: right;
  text-align: center;
}
.desc-wrapper .right .imgs{
  width: 100px;
  height: 100px;
}
img{
  display: block;
  width: 100%;
  height: 100%;
}
.desc-wrapper .right .txt{
  font-size: 14px;
}
.desc{
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}
.desc .s1{
  padding-left: 25px;
  background: url('../assets/images/icp.png') no-repeat;
}
.hr{
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/footerBar.vue